import React from 'react';
import { Bar } from 'react-chartjs-2';

import '../../sass/components/charts/ConversionView.scss';

const STROKE_COLOR = '#2196F3';
const FILL_COLOR = 'rgba(33, 150, 243, 0.3)';

export default class ConversionView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render = () => {
    const values = [
      this.props.data.view_page,
      this.props.data.view_deal_details,
      this.props.data.redeem,
    ];
    const maxValue = values.reduce((res, cur) => Math.max(res, cur), values[0]);
    return (
      <div className='conversionView'>
        <div className='chartContainer'>
          <Bar
            data={{
              labels: ['View page', 'View deal details', 'Redeem'],
              datasets: [
                {
                  label: '',
                  data: values,
                  backgroundColor: STROKE_COLOR,
                  borderWidth: 0,
                },
              ]
            }}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false,
                },
                tooltip: {
                  intersect: false,
                  mode: 'x'
                }
              },
              scales: {
                y: {
                  grid: {
                    drawBorder: false
                  },
                  ticks: {
                    stepSize: maxValue ? maxValue / 2 : 1,
                    callback: (value, index, values) => {
                      return maxValue ? `${Math.round(value / maxValue * 100)}%` : value;
                    }
                  }
                },
                x: {
                  grid: {
                    display: false,
                  }
                }
              },
            }}
            plugins={[
              {
                beforeDatasetDraw: (chart, { index, meta }) => {
                  const ctx = chart.ctx;
                  const minY = meta.data.reduce(
                    (res, cur) => res ? Math.min(cur.y, res) : cur.y
                  , null);
                  meta.data.forEach(barElem => {
                    ctx.save();
                    ctx.fillStyle  = FILL_COLOR;
                    ctx.fillRect(
                      barElem.x - (barElem.width / 2),
                      minY,
                      barElem.width,
                      barElem.base - minY
                    );
                    ctx.restore();
                  });
                },
                afterDatasetDraw: (chart, { index, meta }) => {
                  const labels = [
                    this.props.data.view_page,
                    this.props.data.view_deal_details,
                    this.props.data.redeem,
                  ];
                  const ctx = chart.ctx;
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.fillStyle = '#ffffff';
                  meta.data.forEach((barElem, index) => {
                    if (barElem.base - barElem.y < 40) {
                      ctx.fillText(labels[index], barElem.x, barElem.y - 9);
                    } else {
                      ctx.fillText(labels[index], barElem.x, barElem.y + 14);
                    }
                  });
                  ctx.restore();
                },
              }
            ]}
          />
        </div>
        <div className='legend'>
          <label><span style={{backgroundColor: STROKE_COLOR}}/>Beyond users</label>
        </div>
      </div>
    )
  }

}
